export default function WorkGallery4() {
  return (
    <section className="py-10">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0 flex flex-col gap-4">


<div className="hidden sm:block rounded-3xl overflow-hidden">
  <img
    src="/cms1.jpeg"
    alt="Petrol station"
    className="w-full h-full object-cover block"
  />
</div>

<div className="hidden sm:block rounded-3xl overflow-hidden">
  <img
    src="/cms8.jpeg"
    alt="Petrol station"
    className="w-full h-full object-cover block"
  />
</div>


        {/* Row 4 */}
       
          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms9.jpeg"
              alt="Mobile banking"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms10.jpeg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms11.jpeg"
              alt="Petrol station"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms12.jpeg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms13.jpeg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms14.jpeg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms15.jpeg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          <div className="hidden sm:block rounded-3xl overflow-hidden">
            <img
              src="/cms16.jpeg"
              alt="Chase campaign"
              className="w-full h-full object-cover block"
            />
          </div>

          
          


      </div>
    </section>
  );
}